import { Component } from '@angular/core';
import { SettingsService, StorageService } from 'core-lib';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { NavigationEnd, Router, RouterLink, Scroll } from '@angular/router';
import { filter } from 'rxjs';
import { DEMO_FILL_COUNTRY_EVENT } from '../profile-booker-details/profile-booker-details.component';


@Component({
    selector: 'app-demo-settings-selector',
    imports: [SelectModule, DrawerModule, ButtonModule, FormsModule, ReactiveFormsModule, CheckboxModule, RouterLink],
    templateUrl: './demo-settings-selector.component.html',
    styleUrl: './demo-settings-selector.component.scss'
})
export class DemoSettingsSelectorComponent {

  visible:boolean=false;
  isInProfile:boolean=false;

  avTemplates = [ {name: "Lista", value: 1}, {name: "Kortit", value: 2} ];
  
  cardCounts = [ {name: "2",value: 2}, {name: "3",value: 3}, {name: "4", value: 4} ];

  sortingOptions = [ {name: "Oletus",value: "DEFAULT"}, {name: "Hinnat nouseva",value: "PRICE-ASC"}, {name: "Hinnat laskeva", value: "PRICE-DESC"} ];

  settingControls:FormGroup = new FormGroup({
    "availability|presentationStyle": new FormControl(),
    "availability|showPricePerNight": new FormControl(),
    "availability|hideOtherRoomsWhenCodeUsed": new FormControl(),
    "availability|cardCountPerRow": new FormControl(),
    "availability|sorting": new FormControl(),
    "multihotel": new FormControl(),
    "enableDebugMode": new FormControl(),
    "disablePaymentSuccess": new FormControl()
  });

  endpoints:any[];

  constructor(public settings: SettingsService, private router: Router, private storageService: StorageService) {
  }

  ngOnInit() {

    this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((e:any) => {
      if (e.urlAfterRedirects.includes('profile')) {
        this.isInProfile = true;
      }
    });



    

    this.settingControls.get("availability|presentationStyle")?.setValue(this.settings.get('availability.presentationStyle'));
    this.settingControls.get("availability|showPricePerNight")?.setValue(this.settings.get('availability.showPricePerNight'));
    this.settingControls.get("availability|hideOtherRoomsWhenCodeUsed")?.setValue(this.settings.get('availability.hideOtherRoomsWhenCodeUsed'));
    this.settingControls.get("availability|cardCountPerRow")?.setValue(this.settings.get('availability.cardCountPerRow'));
    this.settingControls.get("availability|sorting")?.setValue(this.settings.get('availability.sorting'));

    
    let debugMode = this.storageService.loadSessionStorage('debugMode');
    let enableDebug:boolean = (debugMode && parseInt(debugMode) > 0) ?? false;
    this.settingControls.get('enableDebugMode')?.setValue(enableDebug);


    this.endpoints = this.settings.get('app.endpoints');
    this.settingControls.get('multihotel')?.setValue(this.endpoints.length == 1 ? false : true);

    this.settingControls.get("availability|cardCountPerRow")?.valueChanges.subscribe((val:any) => {
      this.settings.setAndReload("availability.cardCountPerRow", val);
    });

    this.settingControls.get("availability|presentationStyle")?.valueChanges.subscribe((val:any) => {
      this.settings.setAndReload("availability.presentationStyle", val);
    });

    this.settingControls.get("availability|showPricePerNight")?.valueChanges.subscribe((val:any) => {
      this.settings.setAndReload("availability.showPricePerNight", val);
    });
    this.settingControls.get("availability|hideOtherRoomsWhenCodeUsed")?.valueChanges.subscribe((val:any) => {
      this.settings.setAndReload("availability.hideOtherRoomsWhenCodeUsed", val);
    });
    this.settingControls.get("availability|sorting")?.valueChanges.subscribe((val:any) => {
      this.settings.setAndReload("availability.sorting", val);
    });

    this.settingControls.get("multihotel")?.valueChanges.subscribe((val:any) => {
      if (this.endpoints.length == 1) {
        this.endpoints.push({
            "hotelCode": "SISTERHOTEL",
            "endpoint": "https://cloud.hotellinx.com/newhope191124/api"
        });
      }
      else {
        this.endpoints.pop();
      }
      this.settings.setAndReload("app.endpoints", this.endpoints);
    });

    this.settingControls.get("enableDebugMode")?.valueChanges.subscribe((val:any) => {
      this.storageService.saveSessionStorage('debugMode', val ? 1 : 0);
      document.location.reload();
    });

    this.settingControls.get("disablePaymentSuccess")?.valueChanges.subscribe((val:any) => {
      this.storageService.saveSessionStorage('disablePaymentSuccess', val ? 1 : 0);
    });

  }

  fillProfile() {
    const event = new Event('input', { bubbles: true }); 

    let inputIDs = [{
      id: 'first-name',
      value: 'Test'
    },
    {
      id: 'last-name',
      value: 'Test'
    },{
      id: 'email',
      value: 'test@test.fi'
    },{
      id: 'phone-number',
      value: '45611111'
    },{
      id: 'address',
      value: 'Test'
    },{
      id: 'zip-code',
      value: 'Test'
    },
    {
      id: 'city',
      value: 'Test'
    },
    {
      id: 'country',
      value: 'fi'
    }
    ];
    inputIDs.forEach((i:any) => {
      if (i.id == 'country') {
        // p-select -arvoa ei voi asettaa DOM:n kautta, joten profiilikomponentti asettaa sen tapahtumasta
        window.dispatchEvent(new CustomEvent(DEMO_FILL_COUNTRY_EVENT, { detail: i.value }));
      }
      else {
        let inputs = document.querySelectorAll('#'+i.id);
        inputs.forEach((el:any) => {
            el.value = i.value;
            el.dispatchEvent(event);
        });
        
      }
      
    });

  }

}
